import React from 'react';

const EscrowDetailHeader = ({ 
  escrow, 
  formatDate, 
  getStatusBadge, 
  onNavigateBack, 
  onRefresh, 
  onViewOrder 
}) => {
  return (
    <div className="mb-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="flex items-center space-x-4">
          <button
            onClick={onNavigateBack}
            className="p-2 bg-gray-800 border border-gray-700 rounded-lg hover:bg-gray-700 hover:border-[#ff660e] transition-all duration-200"
          >
            <span className="text-gray-300">←</span>
          </button>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-white">
              Escrow <span className="text-[#ff660e]">#{escrow?.escrow_id}</span>
            </h1>
            <div className="flex items-center space-x-4 mt-2">
              {getStatusBadge(escrow?.status)}
              <span className="text-gray-400">
                Created: {formatDate(escrow?.created_at)}
              </span>
            </div>
          </div>
        </div>
        <div className="flex gap-3">
          <button
            onClick={onRefresh}
            className="px-4 py-2.5 bg-gray-800 text-white border border-gray-700 rounded-lg hover:bg-gray-700 hover:border-[#ff660e] transition-all duration-200 font-medium flex items-center hover:scale-[1.02]"
          >
            <span className="mr-2">🔄</span>
            Refresh
          </button>
          {escrow?.order_id && (
            <button
              onClick={onViewOrder}
              className="px-4 py-2.5 bg-gray-800 text-white border border-gray-700 rounded-lg hover:bg-gray-700 hover:border-[#ff660e] transition-all duration-200 font-medium flex items-center hover:scale-[1.02]"
            >
              <span className="mr-2">📦</span>
              View Order
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EscrowDetailHeader;